import React from 'react';

export default function StageBanner({ kind, caption, color, theme }) {
  return (
    <div
      style={{
        position: 'absolute',
        top: 4,
        left: '50%',
        transform: 'translateX(-50%)',
        color,
        background: theme.bannerBg,
        fontFamily: "'Courier New', monospace",
        fontWeight: 700,
        fontSize: 13,
        padding: '6px 14px',
        borderRadius: 0,
        zIndex: 15,
        border: `1px solid ${color}`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        maxWidth: '90%',
        textAlign: 'center',
        boxShadow: '4px 4px 0 rgba(0,0,0,0.16)',
        clipPath: 'polygon(0 0, calc(100% - 9px) 0, 100% 9px, 100% 100%, 0 100%)',
      }}
    >
      <span style={{ letterSpacing: 0.5 }}>{kind}</span>
      <span style={{ color: theme.bannerCaption, fontWeight: 500, fontSize: 11 }}>
        {caption}
      </span>
    </div>
  );
}
